import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SubscriptionActions } from './+state/subscription.actions';

import { SubscriptionFacade } from './+state/subscription.facade';
import { SubscriptionService } from './subscription.service';


@NgModule( {
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [ SubscriptionService, SubscriptionFacade, SubscriptionActions ]
} )
export class SubscriptionModule { }
